import { render, staticRenderFns } from "./DomainReviewTable.vue?vue&type=template&id=5d9810c2&scoped=true"
import script from "./DomainReviewTable.vue?vue&type=script&lang=js"
export * from "./DomainReviewTable.vue?vue&type=script&lang=js"
import style0 from "./DomainReviewTable.vue?vue&type=style&index=0&id=5d9810c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9810c2",
  null
  
)

export default component.exports